import { useAuthStore } from '@/stores';
import { Logger } from '@/middlewares/sentry';

export function handleResponse(response) {
  if (process.env.NODE_ENV === 'development') {
    Logger.info(response);
  }
  return response.data;
}

export async function handleError(response) {
  if (!response) {
    Logger.error('Server connection error ' + response);
    return Promise.reject(new Error('No connection with server.'));
  }

  const error =
    response.status +
    ' ' +
    ((response.data && response.data.error) || 'Unknown Error');
  Logger.error(error);
  return Promise.reject(new Error(error));
}

export async function handleRetryError(error) {
  if (!error.response) {
    Logger.error('Server connection error ' + error);
    throw new Error(
      JSON.stringify({
        status: 408,
        message: 'No connection with server.',
      }),
    );
  }

  if (error.response.status === 401) {
    try {
      Logger.warn('Token error');

      const { refreshToken } = useAuthStore();
      await refreshToken();
    } catch (err) {
      if (err instanceof Error) {
        Logger.error(err);
        throw new Error(
          JSON.stringify({
            status: error.response.status,
            message: err,
          }),
        );
      }

      Logger.error(err);
      throw new Error(
        JSON.stringify({
          status: error.response.status,
          message: err,
        }),
      );
    }

    throw new Error(
      JSON.stringify({
        status: error.response.status,
        message: 'Token expired. Retrying...',
      }),
    );
  } else {
    Logger.error(error);
    throw new Error(
      JSON.stringify({
        status: error.response.status,
        message: error.response.data?.error ?? 'Unknow error',
      }),
    );
  }
}
